import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import Header from './components/Header10';
import Footer from './components/Footer10';

const Signup10 = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.password !== formData.confirmPassword) {
            return;
        }
        navigate('/template10');
    };

    const inputClass = "w-full px-0 py-3.5 bg-transparent text-[#1C1917] text-sm font-light placeholder-[#A8A29E] focus:outline-none transition-colors duration-300";

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <div style={{ fontFamily: "'Inter', sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-16 md:pt-[72px] min-h-[80vh] flex items-center justify-center px-5 md:px-8">
                    <div className="w-full max-w-sm py-12 md:py-20">
                        {/* Header */}
                        <div className="text-center mb-10">
                            <h1 className="text-2xl md:text-3xl font-light text-[#1C1917] tracking-tight mb-2">
                                Create Account
                            </h1>
                            <p className="text-[#A8A29E] text-xs font-light">
                                Join the STHIR community
                            </p>
                        </div>

                        {/* Form */}
                        <form onSubmit={handleSubmit}>
                            {[
                                { name: 'fullName', placeholder: 'Full Name', type: 'text' },
                                { name: 'email', placeholder: 'Email', type: 'email' },
                                { name: 'phone', placeholder: 'Phone', type: 'tel' },
                            ].map((field) => (
                                <div key={field.name} style={{ borderBottom: '1px solid #E7E5E4' }}>
                                    <input
                                        type={field.type}
                                        name={field.name}
                                        placeholder={field.placeholder}
                                        value={formData[field.name]}
                                        onChange={handleInputChange}
                                        className={inputClass}
                                        style={{ fontFamily: "'Inter', sans-serif" }}
                                        required
                                    />
                                </div>
                            ))}

                            <div className="relative" style={{ borderBottom: '1px solid #E7E5E4' }}>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    placeholder="Password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    className={inputClass}
                                    style={{ fontFamily: "'Inter', sans-serif", paddingRight: '40px' }}
                                    required
                                    minLength="8"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-0 top-1/2 -translate-y-1/2 text-[#A8A29E] hover:text-[#78716C] transition-colors bg-transparent border-none cursor-pointer p-2"
                                >
                                    {showPassword
                                        ? <EyeOff className="w-4 h-4" strokeWidth={1.5} />
                                        : <Eye className="w-4 h-4" strokeWidth={1.5} />
                                    }
                                </button>
                            </div>

                            <div style={{ borderBottom: '1px solid #E7E5E4' }}>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="confirmPassword"
                                    placeholder="Confirm Password"
                                    value={formData.confirmPassword}
                                    onChange={handleInputChange}
                                    className={inputClass}
                                    style={{ fontFamily: "'Inter', sans-serif" }}
                                    required
                                    minLength="8"
                                />
                            </div>

                            <div className="mt-6 mb-8">
                                <label className="flex items-start gap-3 cursor-pointer">
                                    <input type="checkbox" required className="mt-0.5 accent-[#78716C]" />
                                    <span className="text-[#A8A29E] text-xs font-light leading-relaxed">
                                        I agree to the{' '}
                                        <span onClick={() => navigate('/template10/terms-conditions')} className="text-[#78716C] underline underline-offset-4 cursor-pointer">
                                            Terms
                                        </span>
                                        {' '}and{' '}
                                        <span onClick={() => navigate('/template10/privacy-policy')} className="text-[#78716C] underline underline-offset-4 cursor-pointer">
                                            Privacy Policy
                                        </span>
                                    </span>
                                </label>
                            </div>

                            <button
                                type="submit"
                                className="w-full py-3.5 bg-[#78716C] text-white text-xs tracking-[2px] uppercase font-normal hover:bg-[#57534E] transition-colors duration-300 cursor-pointer border-none"
                            >
                                Create Account
                            </button>
                        </form>

                        {/* Login Link */}
                        <div className="text-center mt-8">
                            <p className="text-[#A8A29E] text-xs font-light">
                                Already have an account?{' '}
                                <span
                                    onClick={() => navigate('/template10/login')}
                                    className="text-[#78716C] hover:text-[#1C1917] cursor-pointer transition-colors underline underline-offset-4"
                                >
                                    Sign in
                                </span>
                            </p>
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Signup10;
